import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import Icon from 'components/icon2';
import createDebug from 'debug';
import useSnackbar, { Payload } from '.';

const debug = createDebug('evp:snackbar');

function duration(payload: Pick<Payload, 'duration'>): number | null {
  if (payload.duration === null) return null;
  return payload.duration || 5000;
}

export default function DisplaySnackbar(): JSX.Element | null {
  const { payload, pop } = useSnackbar();
  const [current, setCurrent] = useState<Payload | undefined>(undefined);

  useEffect(() => {
    debug(
      'Got Snackbar update. Current %o, queue length: %d',
      current,
      payload.length,
    );
    if (!current && payload.length > 0) {
      debug('Showing new snackbar since we are not currently showing one');
      setCurrent(pop());
    }

    if (current && current.priority === 'low' && payload.length > 0) {
      debug('Replacing Snackbar because current has priority low');
      setCurrent(pop());
    }
  }, [payload.length, current]);

  if (!current) return null;

  return (
    <Snackbar
      open
      message={current.message}
      autoHideDuration={duration(current)}
      onClose={(_, r) => {
        if (r === 'clickaway') return;
        setCurrent(undefined);
      }}
      action={
        <IconButton
          size='small'
          aria-label='close'
          color='inherit'
          onClick={() => setCurrent(undefined)}
        >
          <Icon icon='times' />
        </IconButton>
      }
    />
  );
}
